<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import EmptyState from '@/Components/UI/EmptyState.vue'
import ConversationRow from './ConversationRow.vue'
import { useInboxStore } from '@/stores/useInboxStore'

defineProps({
  conversations: { type: Array, required: true },
  selectedId:    { type: Number, default: null }
})

const { t } = useI18n()
const store = useInboxStore()

const sentinel = ref(null)
let observer = null

onMounted(() => {
  if (!sentinel.value) return
  observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) store.loadMore()
  }, { rootMargin: '120px' })
  observer.observe(sentinel.value)
})

onBeforeUnmount(() => observer?.disconnect())
</script>

<template>
  <div class="flex flex-col h-full">
    <div
      v-if="conversations.length === 0"
      class="flex-1 p-6"
    >
      <EmptyState
        type="first-use"
        :title="t('inbox.empty')"
        :hint="t('inbox.emptyHint')"
      />
    </div>
    <div
      v-else
      class="flex-1 overflow-y-auto bg-[color:var(--surface)]"
    >
      <ConversationRow
        v-for="c in conversations"
        :key="c.id"
        :conv="c"
        :selected="c.id === selectedId"
      />
      <div
        ref="sentinel"
        class="h-8 flex items-center justify-center text-[10px] text-[color:var(--muted)]"
      >
        <span v-if="store.loadingMore">{{ t('inbox.list.loadingMore') }}</span>
        <span v-else-if="!store.hasMore">{{ t('inbox.list.endOfList') }}</span>
      </div>
    </div>
  </div>
</template>
